import { formatPhone as formatPhoneHelper } from "@/utils/helpers";
export const formatPhone = {
  methods: {
    formatPhone(value) {
      return formatPhoneHelper(value);
    }
  }
};
